import main from "@/main";

export default {
    isPrivileged () {
        return main.isPrivileged();
    },

    isContactAdmin () {
        return main.isContactAdmin();
    },

    isAlfaUser () {
        return main.isAlfaUser();
    },

    isDataAdmin () {
        return main.isDataAdmin();
    },

    isDispatcher () {
        return main.isDispatcher();
    },

    isUnitAdmin () {
        return main.isUnitAdmin();
    },

    isSettingsAdmin () {
        return main.isSettingsAdmin();
    },

    isGuardReports () {
        return main.isGuardReports();
    },

    isPlanner () {
        return main.isPlanner();
    },

    isRestrictedDispatcher () {
        return main.isRestrictedDispatcher();
    },

    isDisponent () {
        return main.isDisponent();
    },

    profile () {
        return main.profile();
    }
}